// Region names are display-only CLDR data. Telephone codes and option order stay intact.
export function localizedCountries(countries, locale) {
  if (typeof Intl.DisplayNames !== 'function') return countries
  const names = new Intl.DisplayNames([locale], { type: 'region' })

  return countries.map(country => {
    try { return { ...country, name: names.of(country.iso2.toUpperCase()) || country.name } }
    catch (_) { return country }
  })
}
